import AutoReplace from 'slate-auto-replace';

function makeTypingReplacementShortcut(from, to) {
  return AutoReplace({
    trigger: 'space',
    before: from,
    change: typeof to === 'function' ? to : function (editor) {
      return editor.insertText(to + ' ');
    }
  });
}

export default makeTypingReplacementShortcut;